import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ShieldAlert } from 'lucide-react';

const NoAccess = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md animate-fade-in bg-card p-8 rounded-2xl shadow-sm border border-border text-center">
        <div className="w-16 h-16 bg-destructive/10 text-destructive rounded-full flex items-center justify-center mx-auto mb-6">
          <ShieldAlert className="h-8 w-8" />
        </div>
        
        <h1 className="text-2xl font-heading font-bold text-foreground mb-3">
          Acceso no encontrado
        </h1>
        
        <div className="space-y-4 text-muted-foreground mb-8">
          <p>
            No encontramos un acceso activo asociado con este correo electrónico.
          </p>
          <div className="bg-muted/50 p-4 rounded-xl text-sm text-left">
            <p className="font-semibold text-foreground mb-1">Posibles causas:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>No usaste el mismo correo de tu compra.</li>
              <li>Hubo un error de tipeo al ingresar el correo.</li>
              <li>Tu acceso puede haber expirado o estar inactivo.</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <Button asChild size="lg" className="w-full h-12">
            <Link to="/login">
              Intentar con otro correo
            </Link>
          </Button>
          <Button variant="outline" asChild className="w-full h-12">
            <a href="mailto:soporte@intestinoligero.com" target="_blank" rel="noopener noreferrer">
              Contactar a soporte
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoAccess;
